import { mapActions, mapState } from 'vuex';
import pendingRequest from '@/components/wallet/pending-requests/pending-request/pending-request.vue';
import contentLoaderMixin from '@/mixins/contentLoader';

export default {
  mixins: [
    contentLoaderMixin,
  ],
  components: {
    pendingRequest,
  },
  created() {
    this.getPendingWithdrawals().then(() => {
      this.isComponentReady = true;
    });
  },
  computed: {
    ...mapState('wallet', ['pendingRequests']),
  },
  methods: {
    ...mapActions('wallet', ['getPendingWithdrawals']),
    onSuccess() {
      this.getPendingWithdrawals();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/pending-requests/pending-requests.js